import { useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';

// Hook for authenticated API calls
export const useAuthenticatedFetch = () => {
  const { getIdToken } = useAuth();

  return useMemo(() => {
    const authenticatedFetch = async (url: string, options: RequestInit = {}): Promise<Response> => {
      const token = getIdToken();
      console.log('API call to:', url, 'with ID token present:', !!token);

      const backendUrl = process.env.REACT_APP_BACKEND_URL;
      if (!backendUrl) {
        throw new Error('REACT_APP_BACKEND_URL environment variable is required');
      }
      const fullUrl = url.startsWith('http') ? url : `${backendUrl}${url}`;

      const headers: Record<string, string> = {
        'Content-Type': 'application/json',
        ...(options.headers as Record<string, string>),
      };

      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      } else {
        console.log('No ID token available for API call');
      }

      return fetch(fullUrl, {
        ...options,
        headers,
      });
    };

    return authenticatedFetch;
  }, [getIdToken]);
};